import request from '@/utils/request'

//展示列表
export function deptList(data) {
	return request({
		url: '/sys/dept/',
		method: 'get',
	})
}
// 查找部门根据id
export function deptGet(data) {
	return request({
		url: '/sys/dept/' + data.id,
		method: 'get',
	})
}

// 添加部门
export function addDept(data) {
	return request({
		url: '/sys/dept',
		method: 'post',
		data
	})
}
// 编辑部门
export function updateDept(data) {
	return request({
		url: '/sys/dept',
		method: 'put',
		data
	})
}
// 删除部门
export function deleteDept(data) {
	return request({
		url: '/sys/dept/' + data.deptId,
		method: 'delete',
	})
}